import { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
const StudentHolidays = () => {
    const [holidays, setHolidays] = useState([]);
    useEffect(() => {
        axios.get("/api/student/get-holidays-list")
        .then(response => {
            setHolidays(response.data);
        })
        .catch(error => {
            console.error("Error fetching holidays:", error);
        });
    }, []);

    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">Holidays</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        
                        {holidays.length === 0 ? (
                                <div className="row gy-3 p-10">
                                    <div className="text-center error">No holidays found</div>
                                </div>
                            ) : (
                                holidays.map((holiday, index) => (
                                    <div className="row gy-3 p-10" key={index}>
                                        <div className="col-4 bg-primary p-10 text-center text-white event-section-radius-left">
                                            <div className="h2 p-0">{dayjs(`${holiday.date}`).format('DD')} {dayjs(`${holiday.date}`).format('MMM')} {dayjs(`${holiday.date}`).format('YYYY')}</div>
                                        </div>
                                        <div className="col-8 p-10 event-section event-section-radius-right">
                                            <div className="h5 p-0">{holiday.remark}</div>
                                            <span>{dayjs(`${holiday.date}`).format('dddd')}</span>
                                        </div>
                                    </div>
                                ))
                            )
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    );
};
export default StudentHolidays;